var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"Language","placeholder":" ","prepend-icon":"fal fa-language","items":_vm.locales,"item-value":"id","item-text":"name"},model:{value:(_vm.form.locale),callback:function ($$v) {_vm.$set(_vm.form, "locale", $$v)},expression:"form.locale"}})
}
var staticRenderFns = []

export { render, staticRenderFns }